import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDate, useIsDesktop } from '../../../hooks';
import { FaChevronDown } from 'react-icons/fa';
import { tools } from '../../../utils';
import ArrowBtn from '../../common/arrow_btn';
import './_concertCard.scss';

function ConcertCardItem({ data }) {
  const isDesktop = useIsDesktop(812);
  const [expanded, setExpanded] = useState(false);
  const { day, month } = useDate(data.date);
  const history = useHistory();

  const redirectToLive = (e) => {
    e.preventDefault();
    history.push('/live');
  };

  return isDesktop ? (
    <Link
      to={`/calendar/${data.slug}`}
      id={data.id}
      className='concertCardItemParent'
    >
      {(data.is_live && (
        <div className='liveTooltip' onClick={(e) => redirectToLive(e)}>
          <span>Live</span>
        </div>
      )) ||
        ''}
      <div className='concertCardItem'>
        <div
          className='avatar'
          style={{ backgroundImage: `url(${data.poster})` }}
        />
        <div className='date'>
          {data.to_be_confirmed ? (
            <h3>
              <p className='month'>TBC</p>
            </h3>
          ) : (
            <>
              <h3>
                <p className='day'>{day}</p>
                <p className='month'>{month}</p>
              </h3>
              <div className='dateInfo'>
                <span>START</span>
                <p>
                  {tools.timeConvert(data.time).replace(/\D+/gi, '')}
                  <span className='pmClock'>PM</span>
                </p>
              </div>
            </>
          )}
        </div>
        <div className='concertInfo'>
          <div>
            <h4 dangerouslySetInnerHTML={{ __html: data.title }} />
            <ul>
              {data.artists &&
                data.artists
                  .filter((el) => el.role === 'orchestra')
                  .map((itm, index) => {
                    return (
                      <li key={index} className='concert_orchestra_items'>
                        <span>{itm.name}</span>
                        <span>{itm.country}</span>
                      </li>
                    );
                  })}
            </ul>
          </div>
          <ul className='concert_artists'>
            {data.artists &&
              data.artists
                .filter((el) => el.role === 'conductor')
                .map((itm, index) => {
                  return (
                    <li key={index}>
                      <span>CONDUCTOR:</span>
                      <div
                        className='concert_artists_data'
                        data-tip={`${itm.name} ${itm.surname}`}
                        data-for='artists_tooltip_conductor'
                      >
                        <img
                          src={itm.avatar}
                          alt={`${itm.name} ${itm.surname} img`}
                        />
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${itm.name} ${itm.surname}`,
                          }}
                        />
                      </div>
                    </li>
                  );
                })}

            {data.artists &&
              data.artists
                .filter((el) => el.role === 'soloist')
                .map((itm, index) => {
                  return (
                    <li key={index} className='concertCalendarSoloist'>
                      <span>SOLOISTS:</span>
                      <div
                        className='concert_artists_data'
                        data-tip={`${itm.name} ${itm.surname}`}
                        data-for='artists_tooltip_conductor'
                      >
                        <img
                          src={itm.avatar}
                          alt={`${itm.name} ${itm.surname} img`}
                        />
                        <span
                          dangerouslySetInnerHTML={{
                            __html: `${itm.name} ${itm.surname}`,
                          }}
                        />
                      </div>
                    </li>
                  );
                })}
          </ul>
        </div>
        <div className='concertDirection'>
          <div>
            <div className='directionIcon' />
            <p>{data.location}</p>
            <p>{data.country}</p>
          </div>
          <ArrowBtn
            buttonColor='black'
            url={data.ticket_url}
            title='BUY TICKET'
          />
        </div>
      </div>
    </Link>
  ) : (
    <div className='concert__card' id={data.id}>
      <Link to={`/calendar/${data.slug}`} className='card__section shown'>
        <div
          className='card__img'
          style={{ backgroundImage: `url(${data.poster})` }}
        />

        <div className='card__text'>
          <div className='dates'>
            {data.to_be_confirmed ? (
              <p className='day'>
                <p className='month'>TBC</p>
              </p>
            ) : (
              <>
                <p className='day'>
                  {day}
                  <p className='month'>{month}</p>
                </p>

                <p>
                  <span>START</span>
                  <p className='time'>{tools.timeConvert(data.time)}</p>
                </p>
              </>
            )}
          </div>

          <div className='texts'>
            <h2
              className='title'
              dangerouslySetInnerHTML={{ __html: data.title }}
            />
            <ArrowBtn
              buttonColor='black'
              url={data.ticket_url}
              title='BUY TICKET'
              buttonClass='cardBtn'
            />
          </div>
        </div>
      </Link>
      <Link
        to={`/calendar/${data.url}`}
        className='card__section hidden'
        style={{ maxHeight: expanded ? '60vh' : '0', overflow: 'hidden' }}
      >
        <div
          className='card__location'
          style={{
            backgroundImage: 'url(/media/icons/inclassica/direction.svg)',
          }}
        >
          <p className='place'>{data.location}</p>
          <p className='country'>{data.country}</p>
        </div>
        {data.artists ? (
          <div className='card__orchestras'>
            {data.artists
              .filter((el) => {
                return el.role === 'orchestra';
              })
              .map((orc, i) => {
                return (
                  <p key={i} className='orc__title'>
                    {orc.name}
                    <span className='orc__country'>{orc.country}</span>
                  </p>
                );
              })}
          </div>
        ) : (
          ''
        )}

        {data.artists &&
          data.artists
            .filter((el) => el.role === 'conductor')
            .map((con, index) => {
              return (
                <>
                  <p className='card__artist__type'>CONDUCTOR:</p>
                  <div className='card__artists'>
                    <div className='card__artist'>
                      <div className='artist__img'>
                        <img
                          src={con.avatar}
                          alt={`${con.name} ${con.surname}`}
                        />
                      </div>

                      <p
                        className='artist__title'
                        dangerouslySetInnerHTML={{
                          __html: `${con.name} ${con.surname}`,
                        }}
                      />
                    </div>
                  </div>
                </>
              );
            })}
        {data.artists &&
        data.artists.filter((el) => el.role === 'soloist').length ? (
          <>
            <p className='card__artist__type'>
              {data.artists.filter((el) => el.role === 'soloist').length > 1
                ? 'SOLOISTS'
                : 'SOLOIST'}
              :
            </p>
            {data.artists &&
              data.artists
                .filter((el) => el.role === 'soloist')
                .map((sol, i) => (
                  <>
                    <div className='card__artists'>
                      <div key={i} className='card__artist'>
                        <div className='artist__img'>
                          <img
                            src={sol.avatar}
                            alt={`${sol.name} ${sol.surname}`}
                          />
                        </div>

                        <p
                          className='artist__title'
                          dangerouslySetInnerHTML={{
                            __html: `${sol.name} ${sol.surname}`,
                          }}
                        />
                      </div>
                    </div>
                  </>
                ))}
          </>
        ) : (
          ''
        )}
      </Link>
      <button
        className='card__expand__btn'
        data-clicked={expanded}
        onClick={() => {
          if (tools.canUseDOM && expanded === false) {
            const card = document.getElementById(`${data.id}`);

            window.scrollTo(
              0,
              card.offsetParent.offsetTop + card.offsetTop - 200
            );
          }

          setExpanded(!expanded);
        }}
      >
        <FaChevronDown />
      </button>
    </div>
  );
}

ConcertCardItem.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ConcertCardItem;
